import request, { PATCH } from '../../utils/request';

export default receptacleId => request(`/receptacles/${receptacleId}/invoices`, { method: PATCH });
